export enum LookupFeesRequiredFieldEnum {
    senhaAutorizacao = 1, //campo 4
    nGuiaPrincipal = 2, //campo 5
    tecnicaRealizada = 3, //campo 25
    observacao = 4, //campo 37
}